module.exports = __webpack_public_path__ + "img/not-found-illustration.a6f0d0d5.svg";